import styled from "styled-components";

import React, { useRef, useState } from "react";
import { InputField1 } from "../../InputField1/InputField1";
import SlideImageSelector from "./SlideImageSelector";
import { errorMessage } from "../../../utils/message";
import { useAddSlide, useGetSliderOption } from "../../../hooks/useContent";
import Loading from "../../Loadings/LoadingTable";
import Spinner from "react-bootstrap/Spinner";

const AddSlide = ({ updateTable, setUpdateTable }) => {
  const {
    mutateAsync: addSlide,
    isLoading: reqLoading,
    error: reqError,
  } = useAddSlide();

  const { data, isLoading, isError } = useGetSliderOption();

  const sliderOption = data
    ? data?.data?.SlidesLocation?.map((location) => {
        return { label: location.name, value: location.key };
      })
    : [];

  sliderOption.unshift({ label: "انتخاب کنید", value: "انتخاب کنید" });
  // ref for reset input file

  const modeRef = useRef();
  const [resetInputFile, setResetInput] = useState(false);

  // mode of lcoation Images

  const SLIDE_LOCATION = {
    TOP_SLIDER: "Top",
    CENTER_SLIDER: "Main",
    BOTTOM_COLOR_SLIDER: "Bottom",
  };

  // hooks

  const [slideMode, setSlideMode] = useState("انتخاب کنید");

  const [newSlide, setSlide] = useState({
    slidePhoto: "",
    slideTitle: "",
    slideLink: "",
    mobileSlidePhoto: "",
    slideAttribute: "",
    en_slidePhoto: "",
    en_mobileSlidePhoto: "",
    en_slideLink: "",
    en_slideAttribute: "",
    en_slideTitle: "",
    ar_slidePhoto: "",
    ar_slideTitle: "",
    ar_mobileSlidePhoto: "",
    ar_slideLink: "",
    ar_slideAttribute: "",
  });

  const isValidImg = (event) => {
    let isValid = true;

    const file = event.target.files[0];
    if (
      (file.type !== "image/png" &&
        file.type !== "image/jpg" &&
        file.type !== "image/jpeg") ||
      file.size > 2.0e6
    ) {
      file.size > 2.0e6
        ? errorMessage("فایل انتخاب شده بیشتر از 2 مگ است")
        : errorMessage("فایل انتخاب شده صحیح نیست");
      isValid = false;
      event.target.value = "";
    }
    return isValid;
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    let isValid = true;

    if (e.target?.type === "file") {
      const file = e.target.files[0];
      isValidImg(e) && setSlide({ ...newSlide, [name]: file });
      return 3;
    }

    isValid &&
      setSlide({
        ...newSlide,
        [name]: value,
      });
  };

  const formGenerator = async () => {
    const formData = new FormData();
    formData.append("slidePhoto", newSlide?.slidePhoto);
    formData.append("mobileSlidePhoto", newSlide?.mobileSlidePhoto);
    formData.append("slideLink", newSlide?.slideLink);
    formData.append("slideAttribute", newSlide?.slideAttribute);
    formData.append("slideTitle", newSlide?.slideTitle);
    formData.append("en_slidePhoto", newSlide?.en_slidePhoto);
    formData.append("en_mobileSlidePhoto", newSlide?.en_mobileSlidePhoto);
    formData.append("en_slideLink", newSlide?.en_slideLink);
    formData.append("en_slideAttribute", newSlide?.en_slideAttribute);
    formData.append("en_slideTitle", newSlide?.en_slideTitle);
    formData.append("ar_slidePhoto", newSlide?.ar_slidePhoto);
    formData.append("ar_mobileSlidePhoto", newSlide?.ar_mobileSlidePhoto);
    formData.append("ar_slideLink", newSlide?.ar_slideLink);
    formData.append("ar_slideAttribute", newSlide?.ar_slideAttribute);
    formData.append("ar_slideTitle", newSlide?.ar_slideTitle);
    formData.append("slideLocation", slideMode);

    await addSlide(formData).then((res) => {
      setUpdateTable((before) => !before);
      setSlide({
        slidePhoto: "",
        slideTitle: "",
        slideLink: "",
        mobileSlidePhoto: "",
        slideAttribute: "",
        en_slidePhoto: "",
        en_mobileSlidePhoto: "",
        en_slideLink: "",
        en_slideAttribute: "",
        en_slideTitle: "",
        ar_slidePhoto: "",
        ar_slideTitle: "",
        ar_mobileSlidePhoto: "",
        ar_slideLink: "",
        ar_slideAttribute: "",
      });
      // setSlideMode("انتخاب کنید");
      setResetInput((before) => !before);
    });
  };

  const validateForm = () => {
    if (newSlide.slidePhoto === "") {
      errorMessage("لطفا عکس اسلاید فارسی را وارد کنید");
      return false;
    } else if (slideMode === "انتخاب کنید") {
      errorMessage("لطفا وضعیت اسلایدر را انتخاب کنید");
      return false;
    } else if (newSlide.mobileSlidePhoto === "") {
      errorMessage("لطفا عکس اسلاید فارسی موبایل را وارد کنید");
      return false;
    } else if (newSlide.slideLink === "") {
      errorMessage("لطفا لینک اسلاید فارسی را وارد کنید");
      return false;
    } else if (newSlide.slideAttribute === "") {
      errorMessage("لطفا صفت فارسی اسلاید را وارد کنید");
      return false;
    } else if (newSlide.slideTitle === "") {
      errorMessage("لطفا عنوان فارسی اسلاید را وارد کنید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    validateForm() && formGenerator();
  };

  const handleChangeMode = (e) => {
    const { label, value } = e;
    setSlideMode(value);
  };

  return (
    <AddSlideStyle>
      <AddSlieWrapper>
        <SlideImageSelector
          newSlid={newSlide}
          resetInputFile={resetInputFile}
          handleChange={handleChange}
          handleChangeMode={handleChangeMode}
          sliderOption={sliderOption}
          setSlideMode={setSlideMode}
          slideMode={slideMode}
        />
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              type="text"
              name="slideLink"
              label="لینک تصاویر فارسی"
              onChange={handleChange}
              value={newSlide?.slideLink}
              placeholder="لینک اسلاید .."
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="slideAttribute"
              label="صفت فارسی"
              onChange={handleChange}
              value={newSlide?.slideAttribute}
              placeholder="عنوانی را جهت سِو وارد نمایید.."
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="slideTitle"
              label="عنوان تصاویر فارسی"
              onChange={handleChange}
              value={newSlide?.slideTitle}
              placeholder="عنوان فارسی را وارد نمایید..."
            />
          </RowElement>
        </RowLayoutStyle>
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              type="text"
              name="en_slideLink"
              label="لینک تصاویر انگلیسی"
              onChange={handleChange}
              value={newSlide?.en_slideLink}
              placeholder="لینک اسلاید .."
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="en_slideAttribute"
              label="صفت انگلیسی"
              onChange={handleChange}
              value={newSlide?.en_slideAttribute}
              placeholder="عنوانی را جهت سِو وارد نمایید.."
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="en_slideTitle"
              label="عنوان تصاویر انگلیسی"
              onChange={handleChange}
              value={newSlide?.en_slideTitle}
              placeholder="عنوان فارسی را وارد نمایید..."
            />
          </RowElement>
        </RowLayoutStyle>

        <RowLayoutStyle>
          <RowElement>
            <InputField1
              type="text"
              name="ar_slideLink"
              label="لینک تصاویر عربی"
              onChange={handleChange}
              value={newSlide?.ar_slideLink}
              placeholder="لینک اسلاید .."
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ar_slideAttribute"
              label="صفت عربی"
              onChange={handleChange}
              value={newSlide?.ar_slideAttribute}
              placeholder="عنوانی را جهت سِو وارد نمایید.."
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ar_slideTitle"
              label="عنوان تصاویر عربی"
              onChange={handleChange}
              value={newSlide?.ar_slideTitle}
              placeholder="عنوان فارسی را وارد نمایید..."
            />
          </RowElement>
        </RowLayoutStyle>
        <button type="submit" className="add-slider-btn" onClick={handleSubmit}>
          {reqLoading ? (
            <Spinner animation="border" color="light" />
          ) : (
            <span>ثبت اسلاید</span>
          )}
        </button>
      </AddSlieWrapper>
    </AddSlideStyle>
  );
};

const AddSlideStyle = styled.div`
  .add-slider-btn {
    padding: 0.5rem 1rem;
    min-width: 300px;
    outline: none;
    border-radius: 0.5rem;
    border: none;
    background-color: #0d6efd;
    color: #fff;
    overflow: hidden;
    display: flex;
    max-height: 3rem;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
  }
`;

const AddSlieWrapper = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

export const RowLayoutStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 2rem 0;
`;

export const RowElement = styled.div`
  width: 30%;

  @media only screen and (max-width: 600px) {
    width: 100%;
    font-size: 75% !important;
  }

  @media only screen and (min-width: 600px) {
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    width: 100%;
  }

  @media only screen and (min-width: 992px) {
    width: 30%;
  }
`;

export default AddSlide;
